<div fxLayout="row" fxLayoutAlign="center" ngClass="m-t-xl">
	<div
		fxLayout="column"
		fxFlex.gt-md="95%"
		fxFlex.md="95%"
		fxFlex.sm="100%"
		fxLayoutAlign="center center"
		ngClass.gt-md="p-xxl"
		ngClass.md="p-l"
		ngClass.sm="p-m p-t-xxl"
		ngClass.xs="p-xl p-t-xl"
	>
		<div fxLayout="row" fxLayoutAlign="center" ngClass="p-b-xl">
			<h2
				class="dark-grey-texts"
				i18n="@@homepage_personal_featuredTopics_featuredTopics"
			>
				Featured Topics
			</h2>
		</div>
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column"
			fxLayoutAlign="center"
			ngClass.xs="p-l-xl p-r-xl"
			*ngIf="
				!this.isLoading &&
				featuredTopicsData1 &&
				featuredTopicsData2 &&
				featuredTopicsData3
			"
		>
			<div
				fxLayout.gt-xs="row"
				fxLayout.xs="column"
				fxLayoutGap.gt-sm="3%"
				fxLayoutGap.sm="2%"
				fxLayoutGap.xs="5%"
				fxFlex.lg="95%"
				fxFlex.md="100%"
			>
				<app-featured-topics-card
					[featuredCardData]="featuredTopicsData1"
				></app-featured-topics-card>
				<app-featured-topics-card
					[featuredCardData]="featuredTopicsData2"
				></app-featured-topics-card>
				<app-featured-topics-card
					[featuredCardData]="featuredTopicsData3"
				></app-featured-topics-card>
			</div>
		</div>
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column"
			fxLayoutAlign="center"
			ngClass.xs="p-l-xl p-r-xl"
			*ngIf="
				!this.isLoading &&
				featuredTopicsData1 &&
				featuredTopicsData2 &&
				!featuredTopicsData3
			"
		>
			<div
				fxLayout.gt-xs="row"
				fxLayout.xs="column"
				fxFlex.lg="65%"
				fxFlex.md="90%"
				fxFlex.sm="95%"
				fxLayoutGap.gt-xs="5%"
				fxLayoutGap.xs="5%"
			>
				<app-featured-topics-card
					[featuredCardData]="featuredTopicsData1"
				></app-featured-topics-card>
				<app-featured-topics-card
					[featuredCardData]="featuredTopicsData2"
				></app-featured-topics-card>
			</div>
		</div>
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column"
			fxLayoutAlign="center"
			ngClass.xs="p-l-xl p-r-xl"
			fxFill
			*ngIf="
				!this.isLoading &&
				featuredTopicsData1 &&
				!featuredTopicsData2 &&
				!featuredTopicsData3
			"
			ngClass="p-b-xxl"
		>
			<div
				fxLayout="column"
				fxFlex.gt-md="58%"
				fxFlex.md="72%"
				fxFlex.sm="89%"
				fxLayoutAlign="center"
				fxHide.lt-sm
			>
				<mat-card class="mat-elevation-z2">
					<div fxLayout="row" fxFlex="100%">
						<div fxLayout="column" fxFlex="45%">
							<img src="{{ this.featuredTopicsData1.image }}" />
						</div>
						<div fxLayout="column" fxFlex="60%">
							<mat-card-header>
								<mat-card-title class="inc-span-height">
									{{
										this.featuredTopicsData1?.title?.length > 30
											? this.featuredTopicsData1.title.slice(0, 30) + '...'
											: this.featuredTopicsData1.title
									}}
								</mat-card-title>
								<mat-card-subtitle>
									<mat-chip-listbox
										aria-label="category selection"
										id="chip-list"
										name="chip-list"
										class="whydonate-light"
									>
										<mat-chip class="mat-chip-list-stacked my-chip">
											<span class="mat-subtitle-2">
												{{ this.featuredTopicsData1.category }}
											</span>
										</mat-chip>
									</mat-chip-listbox>
								</mat-card-subtitle>
							</mat-card-header>
							<div ngClass="p-l-m p-r-m">
								<p>
									{{
										this.featuredTopicsData1?.description?.length > 94
											? this.featuredTopicsData1.description.slice(0, 94) +
											  ' ...'
											: this.featuredTopicsData1.description
									}}
								</p>
							</div>
							<div
								*ngIf="featuredTopicsData1.link.includes('/donate/')"
								ngClass="p-l-m"
							>
								<button
									mat-stroked-button
									color="accent"
									(click)="redirectToDonate(featuredTopicsData1.link)"
								>
									<span
										class="mat-headline-6"
										i18n="@@homepage_personal_featuredTopics_donateNow"
										>Donate Now</span
									>
								</button>
							</div>
							<div
								*ngIf="!featuredTopicsData1.link.includes('/donate/')"
								ngClass="p-l-m"
							>
								<button
									mat-stroked-button
									color="accent"
									(click)="redirectToDonate(featuredTopicsData1.link)"
								>
									<span class="mat-headline-6" i18n="@@button_learnMore"
										>Learn More</span
									>
								</button>
							</div>
						</div>
					</div>
				</mat-card>
			</div>
			<div fxLayout="column" fxLayoutGap="5%" fxHide.gt-xs>
				<app-featured-topics-card
					[featuredCardData]="featuredTopicsData1"
				></app-featured-topics-card>
			</div>
		</div>
	</div>
</div>
